import { where, getDocs, query, collection } from "firebase/firestore";
import { db } from "../firebase";

async function getOrgOptionsProducts(orgId) {
  try {
    const optionsProductsRef = collection(db, "OptionProducts");
    const querySnapshot = await getDocs(query(optionsProductsRef, where("orgId", "==", orgId)));
    const optionsProducts = querySnapshot.docs.map((doc) => doc.data());
    return optionsProducts;
  } catch (error) {
    console.error(error);
  }
}

export default getOrgOptionsProducts;
